import React from "react";
import "./Footer.css";
import Logo, { LogoType } from "../Logo/Logo";
import {Link} from "react-router-dom";
import {TranslationsMap} from "../../pages/CountryPage/CountryPage";

interface FooterProps {
  translations: TranslationsMap
}

const Footer: React.FC<FooterProps> = ({translations}) => {
  return (
    <footer className="footer mt-16">
      <Logo type={LogoType.Grey} />
      <Link to={window.location.pathname + "/privacy-policy"}>
        <p className="clickable">{translations["landingPage.footer.privacyPolicy"]}</p>
      </Link>
      <p className="gray-text">DHDK_CORABC1.1_001</p>
    </footer>
  );
}

export default Footer;